module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/family.json
// module id = 330
// module chunks = 109182443054066